import {Avatar, Button, Image, Input, Radio, Tabs} from 'antd'
import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {Formik, FormikConsumer} from 'formik'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useState} from 'react'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import {Pure} from "../../../../components/Pure";
import {compose, mapProps, pure, withProps} from "recompose";
import {deepTranslate, getFullAddress, renderIf, renderIfElse} from "../../../Shared";
import withTranslate from "../../../../modules/local/withTranslate";
import {CountryPicker, renderLocationCascade} from "../../User/functions/renderLocationCascade";
import {useToggle} from "react-use";
import {createControlledFormField} from "../../factory/createFormField";
import PhotoField from "../../custom/PhotoField";
import LookupField from "../../../../components/LookupField";
import {createValue} from "../../../../components/form/utils";
import {appClassNames} from "../../custom/appClassNames";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import {BiSolidChurch} from "react-icons/bi";
import {GoDotFill} from "react-icons/go";
import {GiChurch, GiJeweledChalice} from "react-icons/gi";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {FaCross, FaMinus} from "react-icons/fa6";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {baseFieldTypes} from "../../../../apis/base/baseFieldTypes";
import EmptyHolder from "../../../../components/EmptyHolder";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import {churchTypeOptions} from "../consts/churchTypeOptions";
import {useFeedback} from "../../Feedback/functions/useFeedback";
import {useHistory} from "../../../../modules/navigation/useRouter";
import TooltipApp from "components/TooltipApp";
import {renderDayOfWeek} from "../functions/renderDayOfWeek";
import {RiMapPinFill} from "react-icons/ri";
import {MdChurch} from "react-icons/md";
import {HiViewfinderCircle} from "react-icons/hi2";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import dayjs from "dayjs";
import {ifThenElseMultipleConditions} from "../../../../helpers/ifThenElseMultipleConditions";
import {IoBulb} from "react-icons/io5";
import SlateEditor, {SlateRenderer} from "../../../SlateEditor";
import {ModalEditorToolbar} from "../../../SlateEditor/SlateEditor";
import {isRawContentEmpty} from "../../../SlateEditor/functions/parseRawContent";
import {convertFromString, convertToString} from "../../../SlateEditor/functions";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";
import {LocationStaticMap, ToggleMap} from "../../../../components/form/fields/LocationMap";
import {getCoordinatesStore} from "../../../../helpers/localStorage";
import {showInfoDialog} from "../../factory/createInfoDialog";
import {MassTimeFillSvg} from "../../../../components/Svgs/MassTimeIconSvg";
import {useRequiredLogin} from "../../../Server/useRequiredLogin";
import {useCheckinApi} from "../functions/useCheckinApi";
import Coordinates from "../../../../components/Coordinates/Coordinates";
import {ReligiousFillSvg} from "../../../../components/Svgs/ReligiousIconSvg";

const formSchema = {
    name: {
        title: 'name of church',
        inline: true,
        className: 'flex flex-col md:flex-row gap-3',
        itemClassNames: ['', 'flex-1'],
        children: [
            {
                name: 'church_type',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <SelectWidget
                                name={name}
                                value={value}
                                allowClear={true}
                                className="w-full"
                                style={{minWidth: 120}}
                                placeholder={t('church type')}
                                onChange={(value) => {
                                    onChange(createValue(name, value ?? null))
                                }}
                                options={churchTypeOptions.map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                name: 'name',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate, form}) => ({
                        name,
                        value,
                        onChange,
                        type: 'text',
                        // addonBefore: (
                        //     <Radio.Group
                        //         name={"is_cathedral"}
                        //         value={form?.values?.is_cathedral}
                        //         buttonStyle="solid"
                        //         className="custom-radio-button"
                        //         defaultValue={form?.values?.is_cathedral}
                        //         onChange={(event) => {
                        //             onChange(createValue("is_cathedral", event.target.value))
                        //         }}>
                        //         {Array.from(churchTypeOptions).map(({label, value}) => (
                        //             <React.Fragment key={value}>
                        //                 <Radio.Button value={value}>{translate(label)}</Radio.Button>
                        //             </React.Fragment>
                        //         ))}
                        //     </Radio.Group>
                        // ),
                        placeholder: translate('ex: Notre-Dame Cathedral'),
                    })),
                    pure
                )(Input),
            },
        ],
    },
    contact_phone_name: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'contact name',
                name: 'contact_name',
                component: createControlledFormField({
                    placeholder: 'ex: pastor name',
                    Component: Input,
                }),
            },
            {
                label: 'phone',
                name: 'contact_phone',
                component: createControlledFormField({
                    type: 'tel',
                    placeholder: 'ex: phone',
                    Component: Input,
                }),
            },
        ],
    },
    photo: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-4 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1 md:col-span-3'],
        children: [
            {
                label: 'avatar',
                name: 'photo',
                className: 'h-full flex flex-col',
                component: ({name, value, form, onChange}) => (
                    <div className="flex flex-col gap-1">
                        <PhotoField
                            holder={<BiSolidChurch/>}
                            className="background"
                            style={{padding: 0}}
                            values={_.get(form, 'values')}
                            {...{name, value, onChange}}
                        />
                        <div className="text-center text-xs text-color-500 italic">{`* 256 x 256`}</div>
                    </div>
                ),
            },
            {
                label: 'cover photo',
                name: 'cover_photo',
                component: ({name, value, form, onChange}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <div className="flex flex-col gap-1">
                                    <PhotoField
                                        holder={'./images/find-a-church.webp'}
                                        className="background"
                                        style={{padding: 0}}
                                        values={_.get(form, 'values')}
                                        {...{name, value, onChange}}
                                    />
                                    <span
                                        className="text-xs text-color-500 italic">{`* ${t('description size photo')}`}</span>
                                </div>
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    address: {
        title: 'address',
        children: [
            {
                name: 'address',
                component: compose(
                    withTranslate,
                    mapProps(({onChange, value, translate}) => ({
                        onChange,
                        value,
                        name: 'address',
                        placeholder: translate('address'),
                        type: 'text',
                    }))
                )(Input),
            },
        ],
    },
    country: {
        title: 'country',
        children: [
            {
                name: 'country_id',
                component: compose(
                    withProps({
                        withChangedValues: (values) => ({
                            location: [, , ,],
                        }),
                    })
                )(CountryPicker),
            },
        ],
    },
    location: {
        title: 'Province/ward',
        children: [
            {
                name: 'location',
                component: ({form, name, value, onChange}) =>
                    renderLocationCascade({
                        name,
                        value,
                        onChange,
                        country_id: _.get(form, 'values.country_id'),
                    }),
            },
        ],
    },
    church_parent: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'belong to parish',
                name: 'parish',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose parish')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.parish_name}
                                            selectedOption={form?.values?.parish}
                                            placeholder={t('click to select / create')}
                                            apiPath={`/lookup/parish/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, diocese_fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        {renderIf(
                                                            !isSm,
                                                            <Avatar
                                                                size={50}
                                                                src={o.avatar}
                                                                className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                                icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                            />
                                                        )}
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                                <span className="font-bold text-sm text-color-000">
                                                                    {fullname}
                                                                </span>
                                                                <span
                                                                    className="font-medium text-xs text-blue-500 italic leading-snug">
                                                                    {`( ${diocese_fullname} )`}
                                                                </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                        {location_address}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    parish: e.target,
                                                    parish_name: e.target.value,
                                                    parish_id: e.target.id,
                                                    diocese: e.target.diocese,
                                                    diocese_name: e.target?.diocese?.name,
                                                    diocese_id: e.target?.diocese?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
            {
                label: 'diocese',
                name: 'diocese',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            isLoginRequired={true}
                                            title={t('choose diocese')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.diocese_name}
                                            selectedOption={form?.values?.diocese}
                                            apiPath={`/lookup/diocese/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        <Avatar
                                                            size={50}
                                                            src={o.avatar}
                                                            className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                            icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                        />
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                              <span className="font-bold text-sm text-color-000">
                                                                  {fullname}
                                                              </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                    {location_address}
                                                                  </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    diocese: e.target,
                                                    diocese_name: e.target?.value,
                                                    diocese_id: e.target?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
        ],
    },
    church_religious_order_parent: {
        title: 'of a religious order',
        children: [
            {
                name: 'religious_order',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose religious order')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.religious_order_name}
                                            selectedOption={form?.values?.religious_order}
                                            placeholder={t('click to select / create')}
                                            apiPath={`/lookup/religious_order/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-2 border border-color-50 hover:shadow-md rounded-lg relative" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        <Avatar
                                                            size={60}
                                                            src={o.avatar}
                                                            icon={<ReligiousFillSvg size={30}
                                                                                    className="text-color-500"/>}
                                                            className="flex flex-center background-200 rounded-l-lg rounded-r-0"
                                                        />
                                                        <div className="flex flex-col gap-1 flex-1">
                                      <span className="font-bold text-color-000 leading-tight">
                                        {o.name}
                                      </span>
                                                            {renderIfElse(
                                                                o?.religious_order_group,
                                                                <span
                                                                    className="font-medium text-xs text-blue-500 italic">
                                            {o?.religious_order_group}
                                          </span>,
                                                                <span
                                                                    className="text-xs text-color-400 italic max-lines-2">
                                            {o?.description}
                                          </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    religious_order: e.target,
                                                    religious_order_name: e.target.value,
                                                    religious_order_id: e.target.id
                                                })
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
        ],
    },
    status_group: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'active',
                name: 'active',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Radio.Group
                                name={name}
                                value={value}
                                onChange={onChange}
                                buttonStyle="solid"
                                optionType="button"
                                className="w-full custom-radio-button"
                                options={baseFieldTypes.active.map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },

    church_categories: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                label: 'major basilica',
                name: 'is_basilica',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Radio.Group
                                name={name}
                                value={value}
                                onChange={onChange}
                                buttonStyle="solid"
                                optionType="button"
                                className="w-full custom-radio-button"
                                options={baseFieldTypes.yesno.map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'minor basilica',
                name: 'is_minor_basilica',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Radio.Group
                                name={name}
                                value={value}
                                onChange={onChange}
                                buttonStyle="solid"
                                optionType="button"
                                className="w-full custom-radio-button"
                                options={baseFieldTypes.yesno.map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'pilgrimage center',
                name: 'is_pilgrimage_center',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Radio.Group
                                name={name}
                                value={value}
                                onChange={onChange}
                                buttonStyle="solid"
                                optionType="button"
                                className="w-full custom-radio-button"
                                options={baseFieldTypes.yesno.map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'cathedral',
                name: 'is_cathedral',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Radio.Group
                                name={name}
                                value={value}
                                onChange={onChange}
                                buttonStyle="solid"
                                optionType="button"
                                className="w-full custom-radio-button"
                                options={baseFieldTypes.yesno.map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    about: {
        children: [
            {
                name: 'about',
                component: createControlledFormField({
                    Component: SlateEditor,
                    ToolbarComponent: ModalEditorToolbar,
                    className: 'background rounded-lg',
                    withProps: ({value}) => ({
                        defaultValue: value,
                    }),
                    withValues: ({resetKey}) => ({
                        resetKey,
                    }),
                }),
            },
        ],
    },
}

export const DetailModalContent = ({reportAccess = true, item, onCancel}) => {
    const t = useTranslate()
    const {isSm, isLg} = useContext(LayoutContext)
    const history = useHistory();
    const [current, setCurrent] = useState(0)
    const handleRequiredLogin = useRequiredLogin()

    const {
        id,
        name,
        photo, cover_photo,
        contact_name,
        contact_phone,
        diocese,
        deanery,
        parish,
        address,
        mass_times = [],
        country,
        ward,
        district,
        province,
        is_cathedral,
        church_type,
        is_basilica,
        is_minor_basilica,
        is_pilgrimage_center,
    } = item ?? {}

    const renderMassItem = (e, i) => {
        const {title, special_event_flag, children = []} = e ?? {}
        const event_date = children.map(ee => ee?.special_event_datetime)
        const special_date = formatDate(event_date[0], 'DD/MM/YYYY')

        const week_label = renderDayOfWeek(item?.weekdays);

        return (
            <div key={i}
                 className={special_event_flag === 1 ? dayjs(special_date).isBefore(dayjs()) ? 'flex flex-col' : 'hidden' : "flex flex-col"}>
                <div className="flex items-center gap-2 mb-1">
                    {renderIf(
                        special_event_flag === 1,
                        <GiJeweledChalice size={12} className="text-green-500"/>
                    )}
                    <div className="flex-1 space-x-1 leading-tight text-base">
                        <span className="font-bold text-color-000">
                            {`${title} :`}
                        </span>
                        <span className="font-normal text-color-100 italic">
                            {week_label}
                        </span>
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-1">
                    {children?.map((ee, i) => {
                        const startTime = dayjs(ee.start_time, "HH:mm:ss");
                        const time = formatDate(startTime, 'HH:mm') || t('0000000')
                        return (
                            <div key={i} className="flex flex-col">
                                <div className="flex items-center gap-1 leading-snug">
                                    <FaMinus size={7} className="text-blue-700"/>
                                    <span style={{letterSpacing: '0.15em'}} className="font-semibold text-base text-blue-500">
                                        {renderIfElse(
                                            special_event_flag === 1,
                                            formatDate(ee?.special_event_datetime, 'HH:mm - DD/MM/YYYY'),
                                            time
                                        )}
                                    </span>
                                    {renderIf(
                                        ee?.language !== 'vi',
                                        <span className="ml-2 font-bold text-sm text-primary italic opacity-60">
                                            {t(ee?.language)}
                                        </span>
                                    )}
                                </div>
                                {renderIf(
                                    ee?.description,
                                    <span className="text-xs text-color-400 italic leading-snug tracking-wide">
                                        {`* ${ee?.description}`}
                                    </span>
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

    const normal_event = mass_times.filter(e => e.special_event_flag !== 1 && e.sunday_mass_flag !== 1).map(renderMassItem)
    const sunday_mass = mass_times.filter(e => e.sunday_mass_flag === 1 && e.special_event_flag !== 1).map(renderMassItem)
    const special_event = mass_times.filter(e => e.special_event_flag === 1).map(renderMassItem)

    const type_church = _.find(churchTypeOptions, {value: church_type})?.label

    const {reportModal, handleReport} = useFeedback({
        notifyListeners: {}
    })

    const {onCheckIn, checkedInModal} = useCheckinApi({
        item,
        notifyListeners: {}
    })

    return (
        <div className="flex flex-col gap-3">
            <div className="relative custom-img-view">
                <Image
                    src={cover_photo || photo || '/images/find-a-church.webp'}
                    fallback={'/images/find-a-church.webp'}
                    style={{height: isSm ? 150 : 180}}
                    className="rounded-lg object-cover"
                    wrapperClassName="rounded-lg"
                    preview={{
                        mask: (
                            <div className="w-full h-full relative">
                                <HiViewfinderCircle
                                    size={16}
                                    style={{top: 10, right: 10}}
                                    className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                />
                            </div>
                        ),
                    }}
                />
                {renderIf(
                    !!is_cathedral,
                    <TooltipApp title={t('cathedral')} placement="right" classNames={{root: "font-medium text-xs italic"}}>
                        <GiChurch
                            size={30}
                            style={{top: 10, left: 10}}
                            className="absolute opacity-75 hover:opacity-100 text-primary-500 hover:text-primary-700 cursor-pointer"
                        />
                    </TooltipApp>
                )}
            </div>
            <div className="flex items-center gap-x-3 text-sm italic border-b border-green-500">
                <span className="flex-1 font-bold text-green-600 tracking-widest">
                    <GoDotFill size={10} className="mr-1"/>
                    {t(type_church)}
                </span>
                {renderIf(
                    _.some([is_basilica === 1, is_pilgrimage_center === 1, is_minor_basilica === 1]),
                    <span className="font-semibold text-green-600 tracking-widest">
                                <GoDotFill size={10} className="mr-1"/>
                        {ifThenElseMultipleConditions(
                            null,
                            is_basilica === 1, t('major basilica'),
                            is_pilgrimage_center === 1, t('pilgrimage center'),
                            is_minor_basilica === 1, t('minor basilica'),
                        )}
                            </span>
                )}
            </div>
            <div className="flex flex-col gap-1">
                <div className="mt-1">
                    <BiSolidChurch size={17} className="mr-2 text-primary-500 inline-block"/>
                    <label className="font-bold text-lg text-primary uppercase tracking-wider leading-tight">
                        {name}
                    </label>
                </div>
                <div className="flex flex-col gap-1 ml-1">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-1">
                        <ItemInformation showIcon={true} className="text-sm lg:text-xs" label="diocese"
                                         value={diocese?.fullname}/>
                        {renderIf(
                            deanery,
                            <ItemInformation showIcon={true} className="text-sm lg:text-xs" label="deanery"
                                             value={deanery?.fullname}/>
                        )}
                        {renderIf(
                            parish,
                            <ItemInformation showIcon={true} className="text-sm lg:text-xs" label="parish"
                                             value={parish?.fullname}/>
                        )}
                    </div>
                    {renderIf(
                        _.some([contact_name, contact_phone]),
                        <div className="flex-1 items-baseline gap-1 text-sm lg:text-xs">
                            <GoDotFill size={10} className="text-color-400"/>
                            {renderIf(
                                !isSm,
                                <span className="text-color-400 whitespace-no-wrap italic">
                                    {`${t('contact')} : `}
                                </span>
                            )}
                            {renderIfElse(
                                contact_name && contact_phone,
                                <span className="flex-1 font-bold text-color-000">
                                    {`${contact_name} - ${contact_phone}`}
                                </span>,
                                <span className="flex-1 font-bold text-color-000">
                                    {contact_name || contact_phone}
                                </span>
                            )}
                        </div>
                    )}
                    {renderIf(
                        _.some([address, country?.location_name, ward?.location_name, district?.location_name, province?.location_name]),
                        <div className="flex-1 items-baseline gap-1 text-xs">
                            <GoDotFill size={10} className="text-color-400"/>
                            {renderIf(
                                !isSm,
                                <span className="ml-1 text-color-400 whitespace-no-wrap italic">
                                    {`${t('address')} : `}
                                </span>
                            )}
                            <span className="flex-1 font-bold text-color-000">
                                {getFullAddress(item)}
                            </span>
                        </div>
                    )}
                </div>
            </div>
            <Tabs
                centered size="small"
                activeKey={current}
                tabBarGutter={16}
                tabBarStyle={{margin: 0}}
                onChange={setCurrent}
                items={[
                    {
                        key: 0,
                        label: t('basic info'),
                        children: (
                            <div className="mt-3 flex flex-col gap-6">
                                {!isRawContentEmpty(item?.about) ? (
                                    <div style={{fontSize: 12}} className="flex flex-col gap-2 ">
                                        <SlateRenderer value={convertFromString(item?.about)} className="max-lines-3"/>
                                        <div
                                            onClick={() => setCurrent(1)}
                                            className="text-right font-normal text-xs text-color-400 hover:text-color-100 italic tracking-wide cursor-pointer">
                                            {`${t('see more')}...`}
                                        </div>
                                    </div>
                                ) : null}
                                <div className="flex flex-col gap-2">
                                    <div className="flex flex-col">
                                        <div className="font-semibold text-base text-gray-800 tracking-wide">
                                            {t('mass times information')}
                                        </div>
                                        <div className="w-20 h-1 my-1 rounded-full bg-gray-400"/>
                                    </div>
                                    {renderIfElse(
                                        mass_times.length > 0,
                                        <div style={{marginLeft: 4}} className="flex flex-col gap-2">
                                            {renderIf(
                                                normal_event.length > 0,
                                                <div className="flex flex-col gap-1">
                                                    <div className="flex items-center gap-1 text-color-200">
                                                        <GoDotFill size={14} className="text-color-400"/>
                                                        <span
                                                            className="font-semibold text-xs uppercase italic tracking-wide">
                                                            {t('daily mass')}
                                                        </span>
                                                    </div>
                                                    <div className="ml-4 grid grid-cols-1 md:grid-cols-2 gap-2">
                                                        {normal_event}
                                                    </div>
                                                </div>
                                            )}
                                            {renderIfElse(
                                                sunday_mass.length > 0,
                                                <div className="flex flex-col gap-1">
                                                    <div className="flex items-center gap-1 text-color-200">
                                                        <GoDotFill size={14} className="text-color-400"/>
                                                        <span
                                                            className="font-semibold text-xs uppercase italic tracking-wide">
                                                            {t('sunday mass')}
                                                        </span>
                                                    </div>
                                                    <div className="ml-4 grid grid-cols-1 md:grid-cols-2 gap-2">
                                                        {sunday_mass}
                                                    </div>
                                                </div>
                                            )}
                                            {renderIf(
                                                special_event.length > 0,
                                                <div className="flex flex-col gap-1">
                                                    <div className="flex items-center flex-1 gap-1 text-green-600">
                                                        <GoDotFill size={14}/>
                                                        <span
                                                            className="font-bold text-xs uppercase italic tracking-wide">
                                                            {t('special mass')}
                                                        </span>
                                                    </div>
                                                    <div className="ml-4 grid grid-cols-1 md:grid-cols-2 gap-2">
                                                        {special_event}
                                                    </div>
                                                </div>
                                            )}
                                        </div>,
                                        <EmptyHolder
                                            icon={() => (
                                                <MassTimeFillSvg size={40} className="text-color-500"/>
                                            )}
                                            title="the parish has not updated yet"
                                            subTitle="the parish has not updated yet description"
                                        />
                                    )}
                                    <div className="text-center">
                                        <Link
                                            to={getLinkToDetail(item)} target="_blank"
                                            style={{ borderRadius: 999 }}
                                            className="px-3 py-1 background-200 hover:bg-primary-50 font-normal text-color-300 tracking-wide no-underline">
                                            {t('view detail')}
                                        </Link>
                                    </div>
                                </div>
                                <div className="mt-3 flex flex-col gap-3">
                                    <Coordinates>
                                        <Button
                                            onClick={() => {
                                                const {latitude, longitude} = getCoordinatesStore();
                                                if (!(!!latitude && !!longitude)) {
                                                    showInfoDialog({
                                                        title: t("Location access required"),
                                                        message: t("Please enable location access to proceed with check-in."),
                                                        translate: t
                                                    })
                                                } else {
                                                    onCheckIn({latitude, longitude}, {
                                                        owner_type: 'church',
                                                        owner_id: id
                                                    })
                                                }
                                            }}
                                            color="primary" variant="solid"
                                            style={{
                                                width: 'fit-content',
                                                padding: '1.25rem 1.5rem',
                                                borderRadius: '0.75rem'
                                            }}
                                            className="mx-auto font-semibold text-base shadow-lg">
                                            {t('tap to checkin')}
                                        </Button>
                                    </Coordinates>
                                    <div className="space-x-1 tracking-wider">
                                        <span className="font-semibold text-gray-600">
                                            {`* ${t('note')}: `}
                                        </span>
                                        <span className="text-color-200 italic">
                                            {`${t('note pilgrimage checkin description')}.`}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )
                    },
                    {
                        key: 1,
                        label: t('about church'),
                        children: (
                            <div className="mt-3">
                                {renderIfElse(
                                    !isRawContentEmpty(item?.about),
                                    <div style={{fontSize: 13}}>
                                        <SlateRenderer value={convertFromString(item?.about)}/>
                                    </div>,
                                    <EmptyHolder/>
                                )}
                            </div>
                        ),
                    }
                ]}
            />
            <div className="mt-2 flex items-center">
                {renderIfElse(
                    reportAccess === true,
                    <div className="flex flex-col flex-1">
                        <div
                            onClick={() => {
                                handleReport({
                                    ref_type: 'church',
                                    ref_id: id,
                                    feedback_category_id: 'church-information'
                                })
                            }}
                            className="flex items-center flex-1 gap-2 text-yellow-400 hover:text-yellow-500 cursor-pointer">
                            <IoBulb size={15} className="text-yellow-400"/>
                            <span className="font-medium text-sm italic">{t('submit mass suggestions')}</span>
                        </div>
                        <div className="text-xs text-color-500 italic leading-snug">
                            {`* ${t('Help us keep the Mass schedule accurate and up to date')}`}
                        </div>
                    </div>,
                    <div className="flex-1"/>
                )}
            </div>
            {reportAccess ? reportModal : null}
            {checkedInModal}
        </div>
    )
}

export const CreateChurchForm = ({
                                     onCancel = NullAsDefault,
                                     onSubmit = NullAsDefault,
                                 }) => {
    const t = useTranslate()

    const [isToggle, toggle] = useToggle()

    const validate = (values) => {
        let errors = {}
        _.forEach(['name'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })
        return errors
    }
    const initialValues = {
        name: undefined,
        is_cathedral: 0
    }

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            onPreSubmit={({countryOptions, location, church_parent, church_religious_order_parent, ...values}) => {
                const [province_id = null, ward_id = null] = location || []
                const changes = shallowDiff(values, initialValues)
                return _.omitBy(
                    {
                        ...changes,
                        ward_id,
                        province_id,
                    },
                    _.isUndefined
                )
            }}
            onSubmit={({countryOptions, location, church_parent, church_religious_order_parent, ...values}) => {
                const [province_id = null, ward_id = null] = location || []

                const changes = shallowDiff(values, initialValues)
                onSubmit(_.omitBy(
                    {
                        ...changes,
                        ward_id,
                        province_id,
                    },
                    _.isUndefined
                ))
            }}>
            <div className="flex flex-col gap-3">
                <Pure>
                    <FieldsFactory
                        formSchema={[
                            formSchema.name,
                            formSchema.church_categories,
                            formSchema.church_parent,
                            formSchema.church_religious_order_parent,
                            formSchema.contact_phone_name,
                            formSchema.address,
                            formSchema.country,
                        ]}
                    />
                </Pure>
                <FormikConsumer>
                    {({values}) =>
                        renderIf(
                            values?.country_id === 237,
                            <Pure>
                                <FieldsFactory formSchema={[formSchema.location]}/>
                            </Pure>
                        )
                    }
                </FormikConsumer>
                <FormikConsumer>
                    {({values, setFieldValue, ...restForm}) => {
                        return (
                            <React.Fragment>
                                <ToggleMap
                                    latitude={values?.latitude}
                                    longitude={values?.longitude}
                                    preview_url={values.map_preview}
                                    onClick={toggle}
                                    onRemove={() => {
                                        // restForm.setValues({
                                        //     ...values,
                                        //     latitude: null, longitude: null, map_preview: null
                                        // });
                                        setFieldValue('latitude', null)
                                        setFieldValue('longitude', null)
                                        setFieldValue('map_preview', null)
                                    }}
                                />
                                <LocationStaticMap
                                    locationName={values.name}
                                    toggle={toggle}
                                    isToggle={isToggle}
                                    latLng={[values.latitude, values.longitude]}
                                    onSelect={(_values) => {
                                        // restForm.setValues({
                                        //     ...values,
                                        //     ..._values
                                        // });
                                        const array = Object.keys(_values)
                                        for (let index = 0; index < array.length; index++) {
                                            const name = array[index]
                                            const value = _.get(_values, name)
                                            setFieldValue(name, value)
                                        }
                                    }}
                                />
                            </React.Fragment>
                        )
                    }}
                </FormikConsumer>
                <FieldsFactory
                    formSchema={[
                        formSchema.status_group,
                    ]}
                />

                <FormActionBar submitText="create"/>
            </div>
        </Formik>
    )
}

export const EditChurchForm = ({
                                   item,
                                   initialValues,
                                   onCancel = NullAsDefault,
                                   onSubmit = NullAsDefault,
                               }) => {
    const t = useTranslate()
    const [isToggle, toggle] = useToggle()
    const [current, setCurrent] = useState(0)

    const country = _.get(initialValues, 'country')

    const province_id = _.get(initialValues, 'province.id')
    const district_id = _.get(initialValues, 'district.id')
    const ward_id = _.get(initialValues, 'ward.id')

    const {latitude, longitude, static_map_url} = _.get(initialValues, 'coordinate', {})

    const _loc = []
    if (Boolean(province_id)) {
        _loc.push(province_id)
    }
    if (Boolean(ward_id)) {
        _loc.push(ward_id)
    }

    const _initialValues = {
        location: _loc,
        religious_order_id: _.get(initialValues, 'religious_order.id', ''),
        religious_order_name: _.get(initialValues, 'religious_order_name', ''),
        religious_order: _.get(initialValues, 'religious_order'),
        parish_id: _.get(initialValues, 'parish.id', ''),
        parish_name: _.get(initialValues, 'parish_name', ''),
        parish: _.get(initialValues, 'parish'),
        diocese_id: _.get(initialValues, 'diocese.id', ''),
        diocese_name: _.get(initialValues, 'diocese_name', ''),
        diocese: _.get(initialValues, 'diocese'),
        name: _.get(initialValues, 'name', ''),
        active: _.get(initialValues, 'active', 0),
        is_cathedral: _.get(initialValues, 'is_cathedral', ''),
        is_pilgrimage_center: _.get(initialValues, 'is_pilgrimage_center', 0),
        is_basilica: _.get(initialValues, 'is_basilica', 0),
        is_minor_basilica: _.get(initialValues, 'is_minor_basilica', 0),
        church_type: _.get(initialValues, 'church_type', 3),
        error_status: _.get(initialValues, 'error_status', 0),
        contact_phone: _.get(initialValues, 'contact_phone', ''),
        contact_name: _.get(initialValues, 'contact_name', ''),
        address: _.get(initialValues, 'address', ''),
        countryOptions: country ? [country] : _.get(initialValues, 'country'),
        country_id: _.get(country, 'id'),
        latitude,
        longitude,
        map_preview: static_map_url,
        photo: _.get(initialValues, 'photo', ''),
        cover_photo: _.get(initialValues, 'cover_photo', ''),
        about: convertFromString(_.get(initialValues, 'about')),
    }

    const validate = (values) => {
        let errors = {}
        _.forEach(['name'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onPreSubmit={({countryOptions, location, church_parent, church_religious_order_parent, ...values}) => {
                const [province_id = null, ward_id = null] = location || []
                const changes = shallowDiff(values, _initialValues)
                return _.omitBy(
                    {
                        ...changes,
                        ward_id, province_id,
                    },
                    _.isUndefined
                )
            }}
            onSubmit={({countryOptions, location, church_parent, church_religious_order_parent, about, ...values}) => {
                const [province_id = null, ward_id = null] = location || []
                const changes = shallowDiff(values, initialValues)
                onSubmit(_.omitBy(
                    {
                        ...changes,
                        ward_id, province_id,
                        about: about ? convertToString(about) : undefined,
                    },
                    _.isUndefined
                ))
            }}>
            <div className="flex flex-col gap-3">
                <Pure>
                    <FieldsFactory
                        formSchema={[
                            formSchema.photo,
                            formSchema.name,
                        ]}
                    />
                </Pure>
                <Tabs
                    centered size="small"
                    activeKey={current}
                    tabBarGutter={16}
                    tabBarStyle={{margin: 0}}
                    onChange={setCurrent}
                    items={[
                        {
                            key: 0,
                            label: t('basic info'),
                            children: (
                                <div className="mt-3 flex flex-col gap-3">
                                    <Pure>
                                        <FieldsFactory
                                            formSchema={[
                                                formSchema.church_categories,
                                                formSchema.church_parent,
                                                formSchema.church_religious_order_parent,
                                                formSchema.contact_phone_name,
                                                formSchema.address,
                                                formSchema.country,
                                            ]}
                                        />
                                    </Pure>
                                    <FormikConsumer>
                                        {({values}) =>
                                            renderIf(
                                                values?.country_id === 237,
                                                <Pure>
                                                    <FieldsFactory formSchema={[formSchema.location]}/>
                                                </Pure>
                                            )
                                        }
                                    </FormikConsumer>
                                    <FormikConsumer>
                                        {({values, setFieldValue}) => (
                                            <React.Fragment>
                                                <ToggleMap
                                                    latitude={values?.latitude}
                                                    longitude={values?.longitude}
                                                    onClick={toggle}
                                                    onRemove={() => {
                                                        setFieldValue('latitude', null)
                                                        setFieldValue('longitude', null)
                                                    }}
                                                />
                                                <LocationStaticMap
                                                    locationName={values.name}
                                                    toggle={toggle}
                                                    isToggle={isToggle}
                                                    latLng={[values.latitude, values.longitude]}
                                                    onSelect={(values) => {
                                                        const array = Object.keys(values)
                                                        for (let index = 0; index < array.length; index++) {
                                                            const name = array[index]
                                                            const value = _.get(values, name)
                                                            setFieldValue(name, value)
                                                        }
                                                    }}
                                                />
                                            </React.Fragment>
                                        )}
                                    </FormikConsumer>
                                    <FieldsFactory
                                        formSchema={[
                                            formSchema.status_group,
                                        ]}
                                    />
                                </div>
                            )
                        },
                        {
                            key: 1,
                            label: t('about church'),
                            children: (
                                <div className="mt-3">
                                    <Pure>
                                        <FieldsFactory formSchema={[formSchema.about]}/>
                                    </Pure>
                                </div>
                            ),
                        }
                    ]}
                />
                <FormActionBar submitText="save"/>
            </div>
        </Formik>
    )
}

